// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__Y_0VQ","infoBtn":"quickbooks_infoBtn__1XOHS","formBox":"quickbooks_formBox__3ss92","formFooter":"quickbooks_formFooter__2RQD_"};